import React, { useEffect, useState } from 'react';
import { IconX, IconLoader2 } from '@tabler/icons-react';
import { useVehicleDrivers } from '../../../hooks/useVehicleRequests';

// Picking a driver here only needs driver_employee_id — the backend snapshots the rest.
export default function DriverSearchField({ orgId, value, onSelect, onClear, error }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearch(search), 400);
        return () => clearTimeout(timer);
    }, [search]);

    const { data: drivers, isLoading } = useVehicleDrivers({
        orgId,
        search: debouncedSearch,
        enabled: dropdownOpen,
    });

    const options = drivers || [];

    return (
        <div>
            <label className="block text-sm font-medium mb-5">Staff Driver</label>
            <div className="relative">
                <input
                    type="text"
                    value={dropdownOpen ? search : (value ? `${value.name}${value.employee_no ? ` — ${value.employee_no}` : ''}` : '')}
                    onFocus={() => { setDropdownOpen(true); setSearch(''); }}
                    onBlur={() => setTimeout(() => setDropdownOpen(false), 150)}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search drivers by name..."
                    className={`w-full bg-bg-light border rounded-[4px] px-10 pr-30 py-[8px] text-sm focus:outline-none ${error ? 'border-danger' : 'border-border'}`}
                />
                {value && (
                    <button
                        type="button"
                        onClick={() => { onClear?.(); setSearch(''); }}
                        className="absolute right-10 top-1/2 -translate-y-1/2 text-text-secondary hover:text-text-main"
                    >
                        <IconX size={14} />
                    </button>
                )}
                {dropdownOpen && (
                    <div className="absolute z-10 top-full left-0 right-0 bg-bg-dark border border-border rounded-[4px] shadow-light mt-2 max-h-[180px] overflow-y-auto">
                        {isLoading ? (
                            <div className="px-12 py-10 text-sm text-text-secondary flex items-center gap-8">
                                <IconLoader2 size={14} className="animate-spin" /> Loading...
                            </div>
                        ) : options.length === 0 ? (
                            <div className="px-12 py-10 text-sm text-text-secondary">No drivers found</div>
                        ) : (
                            options.map(driver => (
                                <div
                                    key={driver.id}
                                    onMouseDown={() => { onSelect(driver); setDropdownOpen(false); }}
                                    className={`px-12 py-10 cursor-pointer text-sm hover:bg-bg-light transition-colors ${value?.id === driver.id ? 'bg-primary/5 text-primary font-medium' : 'text-text-main'}`}
                                >
                                    <div className="font-medium">{driver.name}</div>
                                    <div className="text-text-secondary text-xs">
                                        {[driver.employee_no, driver.phone_number].filter(Boolean).join(' · ')}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}
            </div>
            {error && <p className="text-danger text-xs mt-5">{error}</p>}
        </div>
    );
}
